import { containersWithReportingMap } from 'src/common/constants/guideItem';

export function doesContainerSupportContentReporting(containerType) {
  // Note: The container type undefined means the container presentation.layout was not returned from API which by historical reasons occur only for List type content.
  return containersWithReportingMap[containerType] || !containerType;
}
